module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-3.3aca5cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-3.jpg
// module id = WusU
// module chunks = 1